import { addOutsideClickListener } from './_utils.js'

function bindEvents(dropdownElements) {
  dropdownElements.forEach((dropdownElement) => {
    const toggleElement =
      dropdownElement.querySelector('.CtiDropdown-toggle') ||
      dropdownElement.querySelector('.Popover-toggle')

    if (!toggleElement) return

    toggleElement.addEventListener('click', () =>
      toggleDropdown(dropdownElement, toggleElement)
    )
  })
}

function toggleDropdown(dropdownElement, toggleElement) {
  const expandedClass = 'is-expanded'
  const getOpenState = () => !!dropdownElement.classList.contains(expandedClass)
  const isOpen = getOpenState()

  if (!isOpen) {
    addOutsideClickListener(dropdownElement, () => {
      if (getOpenState()) {
        toggleElement.setAttribute('aria-expanded', false)
        dropdownElement.classList.remove(expandedClass)
      }
    })
  }
  toggleElement.setAttribute('aria-expanded', !isOpen)
  dropdownElement.classList.toggle(expandedClass)
}

export default function () {
  const dropdownElements = [
    ...document.querySelectorAll('.CtiDropdown'),
    ...document.querySelectorAll('.Popover'),
  ]

  if (!dropdownElements) return

  bindEvents(dropdownElements)
}
